import messageResource from '../../messageResource'
import {CopySettingsTypes} from './constants'

export function getItemsForCopyTaskSettingsBlock(canManageAccountsAndPermissions,
    billingTypesEnabled,
    estimateEnabled,
    workflowStatusesEnabled,
    workAssignmentsEnabled,
    hasSomeTeamAssignment) {

    return {
        assignmentsSettings: getAssignmentsSettings(canManageAccountsAndPermissions, workAssignmentsEnabled, hasSomeTeamAssignment),
        descriptionSettings: [],
        taskSettings: getTaskSettings({
            workflowStatusesEnabled,
            billingTypesEnabled,
            estimateEnabled,
            descriptionMessageKey: 'task.list.copy_to.task.settings.task_description',
            statusMessageKey: 'task.list.copy_to.task.settings.task_status',
            typeOfWorkMessageKey: 'task.list.copy_to.task.settings.task_type_of_work',
            estimateMessageKey: 'task.list.copy_to.task.settings.task_estimate',
        }),
    }
}

export function getItemsForCopyProjectSettingsBlock(canManageAccountsAndPermissions,
    billingTypesEnabled,
    estimateEnabled,
    workflowStatusesEnabled,
    workAssignmentsEnabled,
    hasSomeTeamAssignment) {

    return {
        assignmentsSettings: getAssignmentsSettings(canManageAccountsAndPermissions, workAssignmentsEnabled, hasSomeTeamAssignment),
        descriptionSettings: getProjectSettings(),
        taskSettings: getTaskSettings({workflowStatusesEnabled, billingTypesEnabled, estimateEnabled}),
    }
}

export function getItemsForCopyCustomerSettingsBlock(canManageAccountsAndPermissions,
    billingTypesEnabled,
    estimateEnabled,
    workflowStatusesEnabled,
    workAssignmentsEnabled,
    hasSomeTeamAssignment) {

    return {
        assignmentsSettings: getAssignmentsSettings(canManageAccountsAndPermissions, workAssignmentsEnabled, hasSomeTeamAssignment),
        descriptionSettings: [...getCustomerSettings(), ...getProjectSettings()],
        taskSettings: getTaskSettings({workflowStatusesEnabled, billingTypesEnabled, estimateEnabled}),
    }
}

function getTaskSettings({
    workflowStatusesEnabled,
    billingTypesEnabled,
    estimateEnabled,
    descriptionMessageKey = 'task.list.copy_to.settings.task_description',
    statusMessageKey = 'task.list.copy_to.settings.task_status',
    typeOfWorkMessageKey = 'task.list.copy_to.settings.task_type_of_work',
    estimateMessageKey = 'task.list.copy_to.settings.task_estimate',
}) {
    let taskSettings = [
        {
            id: CopySettingsTypes.COPY_TASK_DESCRIPTION,
            text: messageResource.getMessage(descriptionMessageKey),
        },
    ]

    if (workflowStatusesEnabled)
        taskSettings.push({
            id: CopySettingsTypes.COPY_TASK_STATUS,
            text: messageResource.getMessage(statusMessageKey),
        })

    if (billingTypesEnabled)
        taskSettings.push({
            id: CopySettingsTypes.COPY_TASK_TYPE_OF_WORK,
            text: messageResource.getMessage(typeOfWorkMessageKey),
        })

    if (estimateEnabled)
        taskSettings.push({
            id: CopySettingsTypes.COPY_TASK_ESTIMATE,
            text: messageResource.getMessage(estimateMessageKey),
        })
    return taskSettings
}

function getAssignmentsSettings(canManageAccountsAndPermissions, workAssignmentsEnabled, hasSomeTeamAssignment) {
    let assignmentsSettings = []

    if(hasSomeTeamAssignment) {
        canManageAccountsAndPermissions && assignmentsSettings.push({
            id: CopySettingsTypes.COPY_MANAGERS,
            text: messageResource.getMessage('task.list.copy_to.settings.managers'),
        })

        workAssignmentsEnabled && assignmentsSettings.push({
            id: CopySettingsTypes.COPY_ASSIGNED_USERS,
            text: canManageAccountsAndPermissions
                ? messageResource.getMessage('task.list.copy_to.settings.assigned_users')
                : messageResource.getMessage('task.list.copy_to.settings.assigned_users_from_my_team'),
        })
    }
    return assignmentsSettings
}

function getProjectSettings() {
    return [
        {
            id: CopySettingsTypes.COPY_PROJECT_DESCRIPTION,
            text: messageResource.getMessage('task.list.copy_to.settings.project_description'),
        },
    ]
}

function getCustomerSettings() {
    return [
        {
            id: CopySettingsTypes.COPY_CUSTOMER_DESCRIPTION,
            text: messageResource.getMessage('task.list.copy_to.settings.customer_description'),
        },
    ]
}



// WEBPACK FOOTER //
// ./web/js/panels/components/utils.js